/**
 * Shadow / elevation tokens.
 *
 * The base elevation matches the Figma swatch shadow
 * `0px 2px 2px rgba(0,0,0,0.05)`. On dark surfaces shadows are subtle, so
 * higher elevations lean on deeper, softer blurs.
 */

export const shadows = {
  none: 'none',
  /** Figma swatch base shadow. */
  xs: '0px 2px 2px 0px rgba(0,0,0,0.05)',
  sm: '0px 2px 4px 0px rgba(0,0,0,0.20)',
  md: '0px 4px 8px 0px rgba(0,0,0,0.28)',
  lg: '0px 8px 16px 0px rgba(0,0,0,0.36)',
  xl: '0px 16px 32px 0px rgba(0,0,0,0.44)',
} as const;

export type ShadowToken = keyof typeof shadows;
